import { useContext } from "react";
import FeatureFlagContext from "./context";
import type { FlagRecord } from "./flags";

const useFlags = () => useContext(FeatureFlagContext).flags as FlagRecord;

const useFlagsLoaded = () => useContext(FeatureFlagContext).loaded;

export { useFlags, useFlagsLoaded };
